import * as React from 'react';
import { Segment } from 'semantic-ui-react';
import ConnectionStatus from 'components/connection-status';
// import OfflineModeSimulator from 'components/offline-mode-simulator';
import * as config from 'config';

import './styles.css';

const CONNECTION_STATUS_DELAY = 5000;

// hidden-mob
export const CertaFooter: React.StatelessComponent = () => {
  return (
    <Segment className="footer no-margin-bottom segment-version">
        <ConnectionStatus
          shouldDisplay={true}
          delay={CONNECTION_STATUS_DELAY}
        />
        {/* <OfflineModeSimulator /> */}
        <span>
          {config.APPLICATION_VERSION}
        </span>
    </Segment>
  );
};


// WEBPACK FOOTER //
// ./src/components/footer/component.tsx